import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { MarketingCampaign } from "../../marketing.types";

export const requestGetMarketingCampaign = async (
  campaignId: string
): Promise<MarketingCampaign> => {
  return await instance.get(`${ApiRoutesMarketing.Campaigns}/${campaignId}`);
};
